import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet } from '_zari/core'

import * as Forms from './forms'

import * as CompaniaService from 'services/compania.service'

const CompaniaConfiguracionSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const [edicionData, setEdicionData] = React.useState(null)

  React.useEffect(() => {
    CompaniaService.obtenerCompaniaConfiguracion()
      .then(({ data }) => {
        setEdicionData(data || {})
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Compania configuracion' />
      <Portlet.Body>{edicionData && <Forms.MainForm edicionData={edicionData} />}</Portlet.Body>
    </Portlet>
  )
}

export default React.memo(CompaniaConfiguracionSection)
